import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ClearDataModal = ({ isOpen, onClose, onConfirm, practitionerName, loading }) => {
  const [confirmText, setConfirmText] = useState('');
  const CONFIRM_PHRASE = 'SUPPRIMER';

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (confirmText === CONFIRM_PHRASE) {
      onConfirm();
    }
  };

  const isConfirmDisabled = confirmText !== CONFIRM_PHRASE || loading;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 animate-fadeIn">
        {/* Warning Icon */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
            <Icon name="AlertTriangle" size={32} className="text-red-600" />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-2xl font-bold text-gray-900 text-center mb-2">
          Supprimer toutes les données
        </h2>

        {/* Warning Message */}
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
          <p className="text-sm text-red-800 font-medium mb-2">
            ⚠️ ATTENTION : Cette action est irréversible !
          </p>
          <p className="text-sm text-red-700">
            Tous les adressages de <strong>{practitionerName}</strong> seront définitivement supprimés.
          </p>
        </div>

        {/* Confirmation Input */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Pour confirmer, tapez <span className="font-bold text-red-600">{CONFIRM_PHRASE}</span>
          </label>
          <input
            type="text"
            value={confirmText}
            onChange={(e) => setConfirmText(e?.target?.value)}
            placeholder="Tapez SUPPRIMER"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
            disabled={loading}
          />
        </div>

        {/* Actions */}
        <div className="flex gap-3">
          <Button
            onClick={onClose}
            disabled={loading}
            className="flex-1 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg font-medium transition-colors disabled:opacity-50"
          >
            Annuler
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={isConfirmDisabled}
            className="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {loading ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                <span>Suppression...</span>
              </>
            ) : (
              <>
                <Icon name="Trash2" size={18} />
                <span>Supprimer tout</span>
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ClearDataModal;